import QuantityStepper from "../../../../components/ui/QuantityStepper";
import { formatBRL } from "../../../../helpers/currency.helper";
import { Row, Texts, Name, Hint, Price } from "./OptionRow.styles";

interface OptionRowProps {
  name: string;
  price: number;
  qty: number;
  onChange: (value: number) => void;
  max?: number;
  hint?: string;
  /** Cardápio-vitrine (/menu): lista o adicional e o preço, sem o seletor de quantidade. */
  readOnly?: boolean;
}

export default function OptionRow({ name, price, qty, onChange, max = 9, hint, readOnly = false }: OptionRowProps) {
  return (
    <Row>
      <Texts>
        <Name>{name}</Name>
        {hint && <Hint>{hint}</Hint>}
      </Texts>
      <Price $active={qty > 0}>+ {formatBRL(price)}</Price>
      {!readOnly && <QuantityStepper value={qty} onChange={onChange} min={0} max={max} size="sm" />}
    </Row>
  );
}
